import { render, staticRenderFns } from "./FlowObjectDetail.vue?vue&type=template&id=2f13aec8"
import script from "./FlowObjectDetail.vue?vue&type=script&lang=js"
export * from "./FlowObjectDetail.vue?vue&type=script&lang=js"
import style0 from "./FlowObjectDetail.vue?vue&type=style&index=0&id=2f13aec8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports